export const IMAGES = {
  heroPoster:
    "https://static.prod-images.emergentagent.com/jobs/2050678f-ee35-4b3e-9e61-8133606d3efb/images/4e8fee1a740c9b262f9b5c589faab2e7b45e9a0455d4b532a74a514d63424612.png",
  marianneBust:
    "https://customer-assets.emergentagent.com/job_theatre-presidentiel/artifacts/eyibgxto_Capture%20d%E2%80%99e%CC%81cran%202026-07-09%20a%CC%80%2004.50.37.png",
  logo:
    "https://static.prod-images.emergentagent.com/jobs/2050678f-ee35-4b3e-9e61-8133606d3efb/images/0bb128eca323608f7acca0364017d4ec3fd60770087ea29ea921b9bc384e2813.png",
  architecture:
    "https://images.unsplash.com/photo-1759523207844-51c953516339?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxmcmVuY2glMjByZXB1YmxpYyUyMGFyY2hpdGVjdHVyZSUyMGVsZWdhbnR8ZW58MHx8fHwxNzgzNTYxNzY2fDA&ixlib=rb-4.1.0&q=85",
};

export const KEY_DATES = {
  preinscription: "2026-09-30T23:59:59",
  officialisation: "2026-12-31T23:59:59",
};

// YouTube — replace with the official VIVA ARTIST channel live video ID once created.
// You can use either a specific video/live ID, or a channel ID for an auto live embed.
export const YOUTUBE = {
  videoId: "aqz-KE-bpKQ", // placeholder demo (embeddable) — replace with VIVA ARTIST live ID
  channelId: "",           // optional: set to auto-embed the channel's current live
};

export const PARTNERS = [
  "La Comédie-Française",
  "INGENIA",
  "Présidence de la République",
  "Sciences Po Paris",
  "l'INS",
];
